import type { DialogResult } from '@quipex/shared/ui';

const ACTIVITY_DESTINATION_FOCUS = 'activity-destination';

export const ACTIVITY_DESTINATION_CLOSE_RESULT = {
    confirm: false,
    data: ACTIVITY_DESTINATION_FOCUS,
} as const satisfies DialogResult;

export function shouldFocusActivityDestination(result: DialogResult): boolean {
    return (
        typeof result === 'object' &&
        result !== null &&
        result.data === ACTIVITY_DESTINATION_FOCUS
    );
}

export function focusActivityDestination(
    document: Document,
    focusDestination: () => void
): void {
    const activeElement = document.activeElement;
    const HTMLElementConstructor = document.defaultView?.HTMLElement;
    if (
        HTMLElementConstructor &&
        activeElement instanceof HTMLElementConstructor &&
        activeElement.closest('[role="dialog"]')
    ) {
        return;
    }

    focusDestination();
}
